import { makeStyles } from '@material-ui/core';
import { FtcSymbolPath } from './FtcSymbolPath';

const useStyles = makeStyles({
  svg: {
    width: '100%',
    height: 36,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 56"
      role="img"
      aria-label="FTCSNS Backstage"
    >
      <defs>
        <linearGradient id="ftcBlueGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#001f33" />
          <stop offset="100%" stopColor="#003b5c" />
        </linearGradient>
      </defs>
      <circle cx="28" cy="28" r="22" fill="url(#ftcBlueGradient)" />
      <svg x="10" y="5" width="36" height="46" viewBox="13 9 40 48" aria-hidden="true">
        <FtcSymbolPath fill="#ffffff" />
      </svg>
      <rect x="54" y="14" width="3.5" height="28" rx="1.5" fill="#c43837" />
      <text x="67" y="25" fill="#ffffff" fontSize="16" fontWeight="700" fontFamily="Arial, sans-serif">
        FTCSNS
      </text>
      <text x="67" y="42" fill="#c7ddeb" fontSize="14" fontWeight="500" fontFamily="Arial, sans-serif">
        Backstage
      </text>
    </svg>
  );
};
